const CLIENTS = ['prisaude', 'solides', 'limer']
const DEFAULT_CLIENT = 'limer'

/**
 * Configuração centralizada de brand por cliente (hostname).
 * Para adicionar ou ajustar um cliente, edite apenas este arquivo.
 */
const brands = {
  limer: {
    id: 'limer',
    hostnameMatch: 'limer',
    title: 'Limer - Saúde Ocupacional',
    favicon: 'favicon-limer.ico',
    colors: {
      loginTheme: '#006bf2',
      usefulLinksIcon: '#FFBA00',
    },
    logos: {
      main: '/logo-limer.png',
      icon: null,
    },
    features: {
      showWhatsappButton: true,
      showHelpDashboard: true,
    },
  },
  prisaude: {
    id: 'prisaude',
    hostnameMatch: 'prisaude',
    title: 'Unimed - Gestão Ocupacional',
    favicon: 'favicon-unimed.ico',
    colors: {
      loginTheme: '#00985E',
      usefulLinksIcon: '#FFBA00',
    },
    logos: {
      main: '/logo-unimed.webp',
      icon: '/icone-unimed.png',
    },
    features: {
      showWhatsappButton: true,
      showHelpDashboard: true,
    },
  },
  solides: {
    id: 'solides',
    hostnameMatch: 'solides',
    title: 'Solides - Gestão Ocupacional',
    favicon: 'favicon-solides.ico',
    colors: {
      loginTheme: '#842F80',
      usefulLinksIcon: '#BC64A0',
    },
    logos: {
      main: 'https://prod-limer.nyc3.cdn.digitaloceanspaces.com/assets/logotipo-solides-claro.webp',
      icon: null,
    },
    features: {
      showWhatsappButton: false,
      showHelpDashboard: false,
    },
  },
}

function getCurrentClient(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  return CLIENTS.find(client => hostname.includes(client)) || DEFAULT_CLIENT
}

function getBrand(client = getCurrentClient()) {
  return brands[client] || brands[DEFAULT_CLIENT]
}

function getBrandHtmlInitScript() {
  const settings = CLIENTS.map(id => ({
    match: brands[id].hostnameMatch,
    title: brands[id].title,
    icon: brands[id].favicon,
  }))

  return `(function () {
  const hostname = window.location.hostname;
  const settings = ${JSON.stringify(settings)};
  const found = settings.find(item => hostname.includes(item.match)) || settings[0];
  document.title = found.title;
  document.querySelector('#dynamic-favicon').href = found.icon;
})();`
}

module.exports = {
  CLIENTS,
  DEFAULT_CLIENT,
  brands,
  getCurrentClient,
  getBrand,
  getBrandHtmlInitScript,
}
